import React from 'react';
import Icon from '../../../../components/Icon/Icon';
import { CustomButton } from '../../../../components/Button/Button';
import styles from './HomeButton.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import Highlighter from 'react-highlight-words';

const HomeButton = ({ label, icon, color, keepIconColor, onClick, disabled, isNew, info, className, searchValue }) => {
  const { t } = useTranslation();

  return (
    <CustomButton className={cx(styles.container, { [styles.disabled]: disabled }, className)} onClick={onClick} disabled={disabled}>
      <div className={styles.infoWrapper}>
        <div className={cx(styles.iconContainer, { [styles.iconColor]: !keepIconColor })} style={{ '--color': color }}>
          <Icon src={icon} className={styles.icon} />
        </div>
        {searchValue ?
          <Highlighter
            highlightClassName="wordHighlighter"
            searchWords={searchValue?.trim().length > 0 ? [searchValue] : ['']}
            autoEscape
            textToHighlight={t(label)}
          /> : <span>{t(label)}</span>}
      </div>
      {info && <InfoTooltip text={info} />}
    </CustomButton>
  );
};

export default HomeButton;
